import { Col, Row } from 'react-bootstrap';
import styles from '../../styles/Loader.module.css';

const NotesComposeSkeleton = ({typeCount = 4,audienceCount = 8}) => {
    return(
        <div className="clientCard">
            <div className={styles.skeletonNotesItemFilterBody}>
                <div className={`${styles.skeletonNotesInboxHeaderText} mb-2`}></div>
                <div>
                    <Row>
                        <Col xs={12} md={6} className='mb-2'>
                            <div className={styles.skeletonNotesComposeDateLabel}></div>
                            <div className={styles.skeletonNotesComposeDate}></div>
                        </Col>
                        <Col xs={12} md={6} className='mb-2'>
                            <div className={styles.skeletonNotesComposeDateLabel}></div>
                            <div className={styles.skeletonNotesComposeDate}></div>
                        </Col>
                        <Col xs={12} className='mb-2'>
                            <div className={styles.skeletonNotesComposeDateLabel}></div>
                            <div className={styles.skeletonNotesComposeTypeAudSelectBtnContainer}>
                                {Array.from({length: typeCount},(_,index) => (
                                    <div key={index} className={styles.skeletonNotesComposeTypeAudSelectBtn}></div>
                                ))}
                            </div>
                        </Col>
                        <Col xs={12} className='mb-2'>
                            <div className={styles.skeletonNotesComposeDateLabel}></div>
                            <div className={styles.skeletonNotesComposeTypeAudSelectBtnContainer}>
                                {Array.from({length: audienceCount},(_,index) => (
                                    <div key={index} className={styles.skeletonNotesComposeTypeAudSelectBtn}></div>
                                ))}
                            </div>
                        </Col>
                        <Col xs={12} className='mb-2'>
                            <div className={styles.skeletonNotesComposeCheckbox}></div>
                        </Col>
                        <Col xs={12} className='mb-2'>
                            <div className={styles.skeletonNotesComposeTextareaLabel}></div>
                            <div className={styles.skeletonNotesComposeTextarea}></div>
                        </Col>
                        <Col xs={12}>
                            <div className='d-flex justify-content-end'>
                                <div className={styles.skeletonNotesComposeSubmitButton}></div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default NotesComposeSkeleton;